import separateThumbs from "../../utils/separateThumbs";

function importAll(r) {
  return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/intro', true, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));

const { media, thumbs } = separateThumbs(allMedia);

export const intro = {
    title: 'Pasta Amatriciana',
    description: 'Rigatoni pasta with crispy pancetta, dried red pepper flakes, canned Italian tomatoes, and pecorino cheese',
    prepTime: 5,
    cookTime: 20,
    totalTime: 25,
    media: media,
    thumbnails: thumbs,
    storySummary: `This Pasta Amatriciana recipe is my rendition on classic Italian amatriciana sauce. Prepared with crispy pancetta, dried red pepper flakes, canned Italian tomatoes, and pecorino cheese, this flavorful pasta sauce packs some heat and comes together in less than 30 minutes! While bucatini or spaghetti is the traditional pasta choice for amatriciana, rigatoni is a great alternative that has quickly become my personal favorite. The deep ridges and large surface area allow the textured sauce to cling really well.`,
    storyMore: ``,
    keywords: ['cheese', 'pancetta', 'pasta', 'red pepper flakes', 'tomato', 'amatriciana sauce', 'amatriciana recipe', 'amatriciana sauce recipe', 'pasta amatriciana', 'rigatoni all amatriciana'],
    recipeCategory: ['dinner'],
    cuisine: ["Italian"],
    id: 'pasta-amatriciana',
    author: 'Restaurant name'
}